<template>
  <div :class="accordionClass" :style="divStyles" @mouseleave="leave">
    <ul>
      <partial-accordion
        v-for="(item, index) in items"
        :item="item"
        :key="index"
        :index="index"
        :styles="styles"
        :active="active"
        @hoverActive="hoverActive"
      ></partial-accordion>
    </ul>
  </div>
</template>
<script>
import partialAccordion from "./vue-accordion-partial.vue";

export default {
  name: "vue-accordion",
  props: {
    items: {
      type: Array
    },
    styles: {
      type: Object,
      default: function() {
        return {};
      }
    },
    accordionClass: {
      type: String,
      default: "vue-accordion"
    }
  },
  data() {
    return {
      active: 0,
      current: 0
    };
  },
  watch: {
    active(val) {
      console.log(val);
    }
  },
  computed: {
    divStyles() {
      return this.styles && this.styles.div ? this.styles.div : {};
    }
  },
  components: {
    partialAccordion
  },
  methods: {
    hoverActive(index) {
      // console.log(index);
      this.active = index;
    },
    getID(item, index) {
      // console.log(item);
      this.current = index;
      this.$parent.getType(item);
    },
    leave() {
      this.active = this.current;
    }
  }
};
</script>
<style>
.vue-accordion {
  width: 100%;
  /* overflow: hidden; */
  height: 280px;
  max-width: 1280px;
}

.vue-accordion ul {
  width: 100%;
  height: 100%;
  display: flex;
  margin: 0;
  padding: 0;
}
.vue-accordion ul li {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/vue-accordion/vue-accordion.vue